import styled from 'styled-components'

import { hexRgba } from '../../../utils/style-fns'
import { grayDark } from '../../../utils/style-utils'

export const Section = styled.div`
  display: flex;
  flex: 1;
  overflow-y: hidden;
  overflow-x: auto;

  background-image: linear-gradient(
    90deg,
    ${hexRgba(grayDark, 0)} 0%,
    ${hexRgba(grayDark, 0.4)} 15%,
    ${hexRgba(grayDark, 0.5)} 40%
  );
`
